import { requestJson } from "../lib/api";

export function registerUser(payload) {
  return requestJson("/api/auth/register", {
    method: "POST",
    body: payload,
  });
}

export function getRegisterOptions() {
  return requestJson("/api/auth/register-options");
}

export function createInstitution(payload) {
  return requestJson("/api/auth/institutions", {
    method: "POST",
    body: payload,
  });
}

export function loginUser(payload) {
  return requestJson("/api/auth/login", {
    method: "POST",
    body: payload,
  });
}

export function getCurrentUser() {
  return requestJson("/api/auth/me");
}

export function confirmPhoneRepair(payload) {
  return requestJson("/api/auth/phone-repair/confirm", {
    method: "POST",
    body: payload,
  });
}

export function markPrizePopupShown() {
  return requestJson("/api/auth/prize-popup/shown", {
    method: "POST",
  });
}

export function logoutUser() {
  return requestJson("/api/auth/logout", {
    method: "POST",
  });
}

export function requestPasswordReset(payload) {
  return requestJson("/api/auth/password-reset/request", {
    method: "POST",
    body: payload,
  });
}

export function verifyPasswordResetToken(token) {
  return requestJson(`/api/auth/password-reset/${encodeURIComponent(token)}`);
}

export function confirmPasswordReset(payload) {
  return requestJson("/api/auth/password-reset/confirm", {
    method: "POST",
    body: payload,
  });
}

export function requestUsernameReminder(payload) {
  return requestJson("/api/auth/username-reminder/request", {
    method: "POST",
    body: payload,
  });
}
